import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge knows Tailwind's default theme names only. These are the token names it lacks (tokens.css and the
// motion utilities of styles.css; ease-out is a default already), so a class passed in replaces its conflict.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      'font-weight': ['regular'],
      animate: [
        'enter',
        'exit',
        'enter-right',
        'exit-right',
        'enter-bottom',
        'exit-bottom',
        'skeleton',
      ],
      ease: ['standard'],
    },
  },
});

// shadcn's classic cn(). The 4.21 registry re-exports it from the npm package `cn`, which is not a dependency here.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
